export default {
  items: [
    {
      name: 'Hem',
      url: '/dashboard',
      icon: 'icon-home',
      role: 'User'
    },
    {
      name: 'Administration',
      url: '/administration',
      icon: 'icon-settings',
      role: 'Auditor',
      children: [
        {
          name: 'Företag',
          url: '/administration/companies',
          icon: 'icon-globe',
          role: 'SuperUser'
        },
        {
          name: 'Användare',
          url: '/administration/users',
          icon: 'icon-people',
          role: 'Auditor'
        },
        {
          name: 'Fordon',
          url: '/administration/benefitvehicles',
          icon: 'fa fa-car',
          role: 'Administrator'
        },
        {
          name: 'Import',
          url: '/administration/import',
          icon: 'icon-cloud-download',
          role: 'Administrator'
        },  
      ]
    },
    {
      name: 'Utgifter',
      url: '/expenses',
      icon: 'icon-note',
      role: 'User',
      children: [
        {
          name: 'Bearbetade',
          url: '/expenses/processed',
          icon: 'cui-dollar icons',
          role: 'Auditor'
        },
        {
          name: 'Trängselskatt',
          url: '/expenses/congestiontax',
          icon: 'cui-dollar icons',
          role: 'User'
        }    
      ]
    },
    {
      name: 'Lönespecifikationer',
      url: '/salaryspecifications',
      icon: 'icon-envelope-letter',
      role: 'User'
    },
  ]
}
